module.exports = __webpack_public_path__ + "static/media/thum2.f217059a.jpg";